import { Router } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import nameOf from 'src/app/shared/form/nameOf.helper';

interface HasOrganizationLevel {
  organizationLevelId: string;
}

const ORG_LEVEL_FILTER_KEY = nameOf<HasOrganizationLevel>(x => x.organizationLevelId) as string;

export function navigateToGridWithOrgFilter(
  router: Router,
  commonService: CommonService,
  route: string,
  extraFilters?: Record<string, string>,
  orgOverrideId?: string | null,
): void {
  const effectiveOrgId = orgOverrideId ?? commonService.selectedOrgEmitter.value?.id;
  const filters: Record<string, string> = { ...extraFilters };
  if (effectiveOrgId != null) {
    filters[ORG_LEVEL_FILTER_KEY] = effectiveOrgId.toString();
  }
  const hasFilters = Object.keys(filters).length > 0;
  if (hasFilters) {
    router.navigate([route], {
      queryParams: { additionalFilters: JSON.stringify(filters) },
    });
  } else {
    router.navigate([route]);
  }
}
